import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { Observable, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UsersMainInfo } from 'src/app/shared/models/graphql';
import { Query } from 'src/app/shared/models/types';
import { AuthService } from '../authentication/auth.service';
import { ErrorHandlerService } from '../http/error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class UserAuthGuard implements CanActivate {
  usersInfoSubscription: Subscription;

  
  constructor(  
    private apollo: Apollo,
    private errorHandlerService: ErrorHandlerService,
    private _Router : Router,
    private _AuthService: AuthService
  ) { }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
 


    return new Promise(resolve => {

      this.usersInfoSubscription = this.apollo.watchQuery<Query>({
        query: UsersMainInfo
      }).valueChanges.pipe(
        map(result => result.data.users),
        catchError(error =>  this.errorHandlerService.handleError(error))
      ).subscribe(users => { 
        if(users[0]){
          resolve(true);
        }else{
          resolve(false);
          this._Router.navigate(["auth/signup/verify-your-account"])
        }
        
      }, error => {
        resolve(false);
        // this._Router.navigate(["auth/signup/verify-your-account"])
      }) 
    })




  }
  
}
